import { connect } from 'react-redux';

const UserAvatar = ({ user, showOnlineStatus = true }) => {
  return (
    <div className='relative flex justify-center gap-2'>
      <div className='relative flex flex-col items-center justify-center'>
        <div className='flex justify-center items-center uppercase bg-[#f99917] rounded-full w-9 h-9 min-h-9 min-w-9 text-center text-black font-semibold'>
          <div className=''>{user.firstName[0]}{user.lastName[0]}</div>
        </div>
        {showOnlineStatus === true &&
          <div className={`leading-[1em] relative top-[-8px] ${user.isOnline === 'offline' ? 'text-red-400' : 'text-green-400'} text-[0.7em] py-[2px] px-1 bg-[#444] rounded font-bold`}>
            {user.isOnline ? 'Online' : 'Offline'}
          </div>
        }
      </div>
      <div className='relative grow text-left overflow-hidden'>
        <div className='grow flex flex-col whitespace-nowrap overflow-hidden leading-[1.2em]'>
          <p className='font-semibold '>{user.firstName} {user.lastName}</p>
          <p className='inline-block opacity-70'> {user.email}</p>
        </div>
      </div>
    </div>
  );
};

// define redux state that will be passed in as props
const mapStateToProps = state => { return {
  //_users: state.serverSynced.users,
}};
export default connect(mapStateToProps, { })(UserAvatar);
